<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5UvoGg/tc-custom/9781572847484.jpg?1705766124994" alt="This image is the cover for the book 1,001 Delicious Soups & Stews, 1,001 Best Recipes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1,001 Delicious Soups & Stews, 1,001 Best Recipes
      </h1>
      <p class="bookDescription body article font2">
        <b>Fill your bowls with year-round favorites from meaty chilis and seafood chowders to vegetarian stews and breads and biscuits to round out your meals.</b><br/>  <br/> A redesigned and reformatted version of a perennial favorite, this fourth edition of <i>1,001 Delicious Soups and Stews</i> delights the palate and soothes the soul, no matter the season. The new edition features streamlined recipes focused on swift and simple preparation and recipe classification information to make recipe selection easier. Hundreds of these wonderful recipes can be prepared in forty-five minutes or less (special icons identify these dishes), and hundreds more are easily found according to preferences for low-carb, low-calorie, and vegetarian options. All recipes are written in a concise format and use readily available ingredients with a focus on fresh, seasonal foods. No special cooking skills or equipment are required—great one-pot meals have never been easier.<br/>  <br/> This comprehensive collection features hundreds of recipes from all over the world, including the Americas, the Mediterranean, China, and India. Readers will find everything from old standbys and comfort-classics to bold chilis, chowders, bisques, fruit soups, and chilled soups. Stick-to-your ribs stews make meal planning easy—they’re substantial enough to be complete, one-pot meals in themselves, and fast and easy enough for weeknight suppers or elegant dinner parties. Either way, readers will never run out of mealtime ideas again!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sue Spitler, Linda R. Yoakam
      </h2>
      
      <p class="authorDescription body article"><B>Sue Spitler</B> is the lead author and editor for Agate Surrey&#8217;s popular <I>1,001</I> cookbook series. She lives in Long Beach, IN. <B>Linda R. Yoakam</B> is a dietitian and nutritional expert with an extensive practice in the Chicago area. She lives in Chicago.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Agate Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53fccd61